import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "70",
  height: "70",
  viewBox: "0 0 70 70",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m26.25 30.625 5.833 5.833 13.125-13.125M20.417 52.5v6.812c0 1.554 0 2.331.318 2.73.277.347.698.55 1.142.549.51 0 1.117-.486 2.33-1.457l6.958-5.566c1.422-1.137 2.132-1.706 2.924-2.11a8.75 8.75 0 0 1 2.221-.78c.87-.178 1.78-.178 3.6-.178h7.34c4.9 0 7.35 0 9.222-.954a8.75 8.75 0 0 0 3.824-3.824c.954-1.871.954-4.322.954-9.222V22.75c0-4.9 0-7.35-.954-9.222a8.75 8.75 0 0 0-3.824-3.824c-1.871-.954-4.322-.954-9.222-.954h-24.5c-4.9 0-7.35 0-9.222.954a8.75 8.75 0 0 0-3.824 3.824c-.954 1.871-.954 4.321-.954 9.222v18.083c0 2.713 0 4.069.298 5.182a8.75 8.75 0 0 0 6.187 6.187c1.113.298 2.47.298 5.182.298z",
      stroke: "#219653",
      "stroke-width": "4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }